import React from 'react';
import Abnormal from '@/pages/dashboard/components/Abnormal';
import { useIntl } from 'umi';

const CardContext = (props: any) => {

  const { children, config, data, dataKey, ...restProps } = props;
  const { formatMessage } = useIntl();

  const isLoading = Array.isArray(dataKey)
    ? dataKey.some((key) => data?.[key]?.loading)
    : data?.[dataKey]?.loading;

  const isError = Array.isArray(dataKey)
    ? dataKey.some((key) => data?.[key]?.errorMsg)
    : data?.[dataKey]?.errorMsg;
  
  const componentItem = (
    // 保证是jsx数组，而不是其他类型数组
    React.Children.map(children, (child: any) => React.cloneElement(
      child,
      {
        ...restProps,
        state: {}
      }
    ))
  );

  return (
    <Abnormal
      isLoading={isLoading}
      isError={isError}
      style={{ background: '#fff', marginTop: '20px', height: '164.5px' }}
      component={componentItem}
      failedMsg={formatMessage({ id: 'common_loading_failed_realtime'})}
    />
  );
};

export default CardContext;